import React from 'react';
import { faqs } from '../data/mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Badge } from './ui/badge';

const FAQSection = () => {
  return (
    <section id="faq" className="relative py-20 bg-gradient-to-br from-[#1a1a2e] via-gray-900 to-[#1a1a2e] overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full opacity-5 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#FF9900] rounded-full opacity-5 blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge className="bg-gradient-to-r from-[#FF9900]/20 to-orange-600/20 text-[#FF9900] hover:bg-gradient-to-r hover:from-[#FF9900]/20 hover:to-orange-600/20 border border-[#FF9900]/30 mb-4">FAQ</Badge>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Trademark Registration FAQs | Copyright & LLC Formation Questions
          </h2>
          <p className="text-xl text-gray-300">
            Common questions about trademark registration services, online trademark filing, federal trademark application, copyright registration, LLC formation, company registration, USPTO filing, trademark search services, and Amazon Brand Registry enrollment answered by expert trademark attorneys.
          </p>
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6">
            {/* Left Column */}
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.slice(0, Math.ceil(faqs.length / 2)).map((faq) => (
                <AccordionItem
                  key={faq.id}
                  value={`item-${faq.id}`}
                  className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl px-6 border border-white/10 hover:border-[#FF9900]/30 transition-colors"
                >
                  <AccordionTrigger className="text-left text-lg font-semibold text-white hover:text-[#FF9900] py-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-300 leading-relaxed pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            {/* Right Column */}
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.slice(Math.ceil(faqs.length / 2)).map((faq) => (
                <AccordionItem
                  key={faq.id}
                  value={`item-${faq.id}`}
                  className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl px-6 border border-white/10 hover:border-[#FF9900]/30 transition-colors"
                >
                  <AccordionTrigger className="text-left text-lg font-semibold text-white hover:text-[#FF9900] py-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-300 leading-relaxed pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>

      {/* Wave Divider Bottom */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none">
        <svg className="relative block w-full h-20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" className="fill-[#232F3E]"></path>
        </svg>
      </div>
    </section>
  );
};

export default FAQSection;